import { useTranslation } from '@gimlite/common';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { Col } from '../col/col.component';
import { Icon, IconType } from '../icon/icon.component';
import { Text } from '../text/text.component';
import './empty.component.scss';
import { Button } from '../button/button.component';

export declare namespace EmptyType {
  type Props = {
    className?: string | null;
    variant?:
      | 'notData'
      | 'errorServer'
      | {
          title?: string | null;
          description?: string | null;
          icon?: IconType.Props['variant'] | null;
        };
    theme?: 'light' | 'dark';
    enableRetry?: boolean;
    onRetry?: () => void;
  };
}

export const Empty = observer(
  ({ variant, className, theme = 'light', enableRetry = false, onRetry }: EmptyType.Props) => {
    const { t } = useTranslation();
    const color = theme === 'light' ? 'deep_indigo_70' : 'white_100';
    return (
      <div className={classNames(`empty`, className)}>
        <div className="empty__content">

        {variant === 'notData' && (
          <Col alignItems="center" justifyContent="center" gap={8}>
            <Icon variant="noData" color={color} size="xxl" />
            <Text variant="title-2" color={color}>
              {t('watermelon-noData')}
            </Text>
            <Col alignItems="center" justifyContent="center" gap={0}>
              <Text variant="body" color={color}>
                {t('watermelon-noDataDescription')}
              </Text>
              <Text variant="body" color={color}>
                {t('watermelon-tryAgainLater')}
              </Text>
            </Col>
          </Col>
        )}
        {variant === 'errorServer' && (
          <Col alignItems="center" justifyContent="center" gap={8}>
            <Icon variant="alarm" color={color} size="xxl" />
            <Text variant="title-2" color={color}>
              {t('watermelon-errorServer')}
            </Text>
            <Col alignItems="center" justifyContent="center" gap={0}>
              <Text variant="body" color={color}>
                {t('watermelon-errorServerDescription')}
              </Text>
              <Text variant="body" color={color}>
                {t('watermelon-tryAgainLater')}
              </Text>
            </Col>
          </Col>
        )}
        {variant && typeof variant === 'object' && (
          <Col alignItems="center" justifyContent="center" gap={8}>
            {variant.icon && (
              <Icon variant={variant.icon} color={color} size="xxl" />
            )}
            {variant.title && (
              <Text variant="title-2" color={color}>
                {variant.title}
              </Text>
            )}
            <Col alignItems="center" justifyContent="center" gap={0}>
              {variant.description && (
                <Text variant="body" color={color}>
                  {variant.description}
                </Text>
              )}
            </Col>
          </Col>
        )}
        </div>

        {enableRetry && (
          <Button  variant="primary" onClick={onRetry}>
            {t('watermelon-retry')}
          </Button>
        )}
  
      </div>
    );
  },
);
